export default {
    state: {
        design: [
            {
                id: 0,
                title: 'Определение стиля',
                text: 'Переносим утвержденный дизайн интерьера на бумагу. В результате вы получаете комплект дизайнерских документов: строительные чертежи, фотореалистичные визуализации, и необходимые спецификации.',
                src: require('~@/../../public/static/images/design/1.jpg'),
                srcset: require('~@/../../public/static/images/design/1.webp'),
            },
            {
                id: 1,
                title: 'Цветовые решения',
                text: 'Переносим утвержденный дизайн интерьера на бумагу. В результате вы получаете комплект дизайнерских документов: строительные чертежи, фотореалистичные визуализации, и необходимые спецификации.',
                src: require('~@/../../public/static/images/design/2.jpg'),
                srcset: require('~@/../../public/static/images/design/2.webp'),
            },
            {
                id: 2,
                title: 'Планировочные решения',
                text: 'Переносим утвержденный дизайн интерьера на бумагу. В результате вы получаете комплект дизайнерских документов: строительные чертежи, фотореалистичные визуализации, и необходимые спецификации.',
                src: require('~@/../../public/static/images/design/3.jpg'),
                srcset: require('~@/../../public/static/images/design/3.webp'),
            },
            {
                id: 3,
                title: 'Бюджет',
                text: 'Переносим утвержденный дизайн интерьера на бумагу. В результате вы получаете комплект дизайнерских документов: строительные чертежи, фотореалистичные визуализации, и необходимые спецификации.',
                src: require('~@/../../public/static/images/design/4.jpg'),
                srcset: require('~@/../../public/static/images/design/4.webp'),
            },
            {
                id: 4,
                title: 'Материалы и предметы',
                text: 'Переносим утвержденный дизайн интерьера на бумагу. В результате вы получаете комплект дизайнерских документов: строительные чертежи, фотореалистичные визуализации, и необходимые спецификации.',
                src: require('~@/../../public/static/images/design/5.jpg'),
                srcset: require('~@/../../public/static/images/design/5.webp'),
            },
            {
                id: 5,
                title: 'Визуализация',
                text: 'Переносим утвержденный дизайн интерьера на бумагу. В результате вы получаете комплект дизайнерских документов: строительные чертежи, фотореалистичные визуализации, и необходимые спецификации.',
                src: require('~@/../../public/static/images/design/6.jpg'),
                srcset: require('~@/../../public/static/images/design/6.webp'),
            },
            {
                id: 6,
                title: 'Чертежи и проекты',
                text: 'Переносим утвержденный дизайн интерьера на бумагу. В результате вы получаете комплект дизайнерских документов: строительные чертежи, фотореалистичные визуализации, и необходимые спецификации.',
                src: require('~@/../../public/static/images/design/7.jpg'),
                srcset: require('~@/../../public/static/images/design/7.webp'),
            },
            {
                id: 7,
                title: 'Надзор',
                text: 'Переносим утвержденный дизайн интерьера на бумагу. В результате вы получаете комплект дизайнерских документов: строительные чертежи, фотореалистичные визуализации, и необходимые спецификации.',
                src: require('~@/../../public/static/images/design/8.jpg'),
                srcset: require('~@/../../public/static/images/design/8.webp'),
            },
        ],
        repair: [
            {
                id: 0,
                title: 'Черновой этап',
                text_1: 'Демонтаж',
                text_2: 'Штукатурка потолка и стен',
                text_3: 'Стяжка полов',
                text_4: 'Звукоизоляция',
                src_1: require('~@/../../public/static/images/repair/1.jpg'),
                srcset_1: require('~@/../../public/static/images/repair/1.webp'),
                src_2: require('~@/../../public/static/images/repair/2.jpg'),
                srcset_2: require('~@/../../public/static/images/repair/2.webp'),
                src_3: require('~@/../../public/static/images/repair/3.jpg'),
                srcset_3: require('~@/../../public/static/images/repair/3.webp'),
                src_4: require('~@/../../public/static/images/repair/4.jpg'),
                srcset_4: require('~@/../../public/static/images/repair/4.webp'),
            },
            {
                id: 1,
                title: 'Инженерные работы',
                text_1: 'Отопление',
                text_2: 'Водоснабжение',
                text_3: 'Электротехнические работы',
                text_4: 'Слаботочный щит',
                text_5: 'Кондиционирование',
                src_1: require('~@/../../public/static/images/repair/5.jpg'),
                srcset_1: require('~@/../../public/static/images/repair/5.webp'),
                src_2: require('~@/../../public/static/images/repair/6.jpg'),
                srcset_2: require('~@/../../public/static/images/repair/6.webp'),
                src_3: require('~@/../../public/static/images/repair/7.jpg'),
                srcset_3: require('~@/../../public/static/images/repair/7.webp'),
                src_4: require('~@/../../public/static/images/repair/8.jpg'),
                srcset_4: require('~@/../../public/static/images/repair/8.webp'),
                src_5: require('~@/../../public/static/images/repair/9.jpg'),
                srcset_5: require('~@/../../public/static/images/repair/9.webp'),
            },
            {
                id: 2,
                title: 'Предчистовая отделка',
                text_1: 'Гипсокартонные работы',
                text_2: 'Предчистовая подготовка - шпатлёвка',
                text_3: 'Напольное покрытие',
                text_4: 'Двери скрытого монтажа',
                text_5: ' Установка карнизов и молдингов и декор. элементов (молдинги, гипс, панели), карнизов',
                src_1: require('~@/../../public/static/images/repair/10.jpg'),
                srcset_1: require('~@/../../public/static/images/repair/10.webp'),
                src_2: require('~@/../../public/static/images/repair/11.jpg'),
                srcset_2: require('~@/../../public/static/images/repair/11.webp'),
                src_3: require('~@/../../public/static/images/repair/12.jpg'),
                srcset_3: require('~@/../../public/static/images/repair/12.webp'),
                src_4: require('~@/../../public/static/images/repair/13.jpg'),
                srcset_4: require('~@/../../public/static/images/repair/13.webp'),
                src_5: require('~@/../../public/static/images/repair/14.jpg'),
                srcset_5: require('~@/../../public/static/images/repair/14.webp'),
            },
            {
                id: 3,
                title: 'Чистовая отделка',
                text_1: 'Декоративные покрытия',
                text_2: 'Монтаж',
                src_1: require('~@/../../public/static/images/repair/15.jpg'),
                srcset_1: require('~@/../../public/static/images/repair/15.webp'),
                src_2: require('~@/../../public/static/images/repair/16.jpg'),
                srcset_2: require('~@/../../public/static/images/repair/16.webp'),
            },
            {
                id: 4,
                title: 'Заключительный этап',
                text_1: 'Меблировка',
                text_2: 'Декорирование',
                text_3: 'Клининг',
                src_1: require('~@/../../public/static/images/repair/17.jpg'),
                srcset_1: require('~@/../../public/static/images/repair/17.webp'),
                src_2: require('~@/../../public/static/images/repair/18.jpg'),
                srcset_2: require('~@/../../public/static/images/repair/18.webp'),
                src_3: require('~@/../../public/static/images/repair/19.jpg'),
                srcset_3: require('~@/../../public/static/images/repair/19.webp'),
            }
        ],
        servicesFilter: 'design'
    },
    mutations: {
        filterDesign: (state) => {
            state.servicesFilter = 'design'
        },
        filterRepair: (state) => {
            state.servicesFilter = 'repair'
        },
    },
    actions: {
        filterIsDesign ({commit}) {
            commit('filterDesign')
        },
        filterIsRepair ({commit}) {
            commit('filterRepair')
        }
    },
    getters: {
        designList (state) {
            return state.design
        },
        repairList (state) {
            return state.repair
        },
        servicesFilterStatus (state) {
            return state.servicesFilter
        }
    }
}
